const isDev = () => {
  return process.env.ENV === 'development' || false;
};

export default isDev;
